import { createRouter, createWebHistory } from 'vue-router';
import RequestManager from "@/script/request.js";
import Connexion from "@/script/Connexion";
import store from './store.js';
// Import des composants
import Home from './components/Home.vue';
import test from './components/test.vue';
import About from './components/About.vue';
import Product from './components/Product.vue';
import Accueil from './components/Accueil.vue';
import NotFound from './components/NotFound.vue';
import Recherche from './components/Recherche.vue';
//import ChoixAppli from './components/ChoixAppli.vue';
import PageConnexion from './components/PageConnexion.vue';
import PageChoixApplication from './components/PageChoixApplication.vue';
import Flic32 from './components/Flic32.vue';
import FicheNouveau from './components/SaisieUtilisateur.vue';
import FicheModif from './components/ModifierPatient.vue';
import ChoixBeneficiareVitale from './components/ChoixBeneficiareVitale.vue';
import AcquisDroitIntegre from './components/AcquisDroitIntegre.vue';
//import LireCarteVitale from './components/LireCarteVitale.vue';
import TransCAM from './components/TransCam/TransCAM.vue';
import Lots from './components/Lot.vue';
import Gestion from './components/Gestion.vue';
import Envois from './components/Envois.vue';
import Vitale from './components/LireCarteVitale.vue';
import Patient from './components/Patient.vue';
import Fse from './components/Fse.vue';
import Parametre from './components/TransCam/Parametre/Parametre.vue';
import Règlement from './components/Règlement.vue';
import TiersPayants from './components/TiersPayants.vue';
import Erreur from './components/Erreur.vue';
import TestCompo from './components/TestCompo.vue';
import ParametrageTable from './components/ParametrageTable.vue';
import MenuParametres from './components/MenuParametres.vue';
import PopupCodeCPS from './components/TransCam/PopupCodeCPS.vue';
import PageListeErreurTransCAMVue from './Page/PageListeErreurTransCAM.vue';
import config from './config.js';
import TransCamRoutes from './TransCamRoutes.js';

// Inscription
import Inscription from './components/Inscription.vue';
import InscriptionReussit from './components/InscriptionReussit.vue';
import InscriptionValidation from './components/InscriptionValidation.vue';
import MotDePasseOublie from './components/MotDePasseOublie.vue';
import Reinitialisation from './components/Reinitialisation.vue';
import PageListeErreurTransCAM from "@/Page/PageListeErreurTransCAM.vue";

//Test FSE
import NewFSE from './components/NewFSE.vue';
import RechercheActes from './components/RechercheActes.vue';


// Définition des routes
const routes = [
    { name: 'TestComposant', path: '/testComposant', component: PopupCodeCPS },
    { name: 'Inscription', path: '/inscription', component: Inscription },
    { name: 'InscriptionReussit', path: '/InscriptionReussit', component: InscriptionReussit },
    { name: 'InscriptionValidation', path: '/InscriptionValidation/:id', component: InscriptionValidation, props: true },
    // Mot de passe oublie : hors session, et /reinitialisation est la cible du lien
    // envoye par courriel — souvent ouvert depuis un autre appareil.
    { name: 'MotDePasseOublie', path: '/mot-de-passe-oublie', component: MotDePasseOublie },
    { name: 'Reinitialisation', path: '/reinitialisation', component: Reinitialisation },
    { name: '', path: '/transCam/parametre', component: Parametre },
    { name: 'Erreur', path: '/Erreur', component: Erreur },
    { name: 'Reglement', path: '/Reglement', component: Règlement },
    { name: 'test', path: '/test', component: test },
    { name: 'SaisieUtilisateur', path: config.urlFrontEnd + '/SaisieUtilisateur', component: FicheNouveau, props: false },
    { name: 'Envois', path: config.urlFrontEnd + '/Envois', component: Envois, props: true },
    { name: 'Product2', path: config.urlFrontEnd + '/product', component: Product, props: true },
    {
        name: 'TransCAM', path: config.urlFrontEnd + '/transcam', component: TransCAM, props: true,
        children: [
            //{ name: 'TransCAM', path: config.urlFrontEnd + '/transcam', component: TransCAM, props: true },

            //Test FSE 
            { name: 'NewFSE', path: config.urlFrontEnd + '/transcam/newfse', component: NewFSE, props: true, meta: { requiresAuth: false } },
            { name: 'RechercheActes', path: config.urlFrontEnd + '/transcam/rechercheactes', component: RechercheActes, props: true, meta: { requiresAuth: false } },

            { name: 'Fse', path: config.urlFrontEnd + '/transcam/Fse', component: Fse, props: true, meta: { requiresAuth: false } },
            { name: 'Gestion', path: config.urlFrontEnd + '/transcam/Gestion', component: Gestion, props: true, meta: { requiresAuth: true } },
            { name: 'Lots', path: config.urlFrontEnd + '/transcam/Lots', component: Lots, props: true, meta: { requiresAuth: true } },
            { name: 'TiersPayants', path: '/transcam/TiersPayants', component: TiersPayants, props: true, meta: { requiresAuth: true } },
            { name: 'Vitale', path: config.urlFrontEnd + '/transcam/LireCarteVitale', component: Vitale, props: true, meta: { requiresAuth: true } },        
            { name: 'ParametreWithComponent', path: '/transCam/parametre/:parametreComposant', component: Parametre, props: true, meta: { requiresAuth: true } },
            { name: 'Patient', path: config.urlFrontEnd + '/transcam/Patient', component: Patient, props: true, meta: { requiresAuth: true } },
            { name: 'ParametrageTable', path: config.urlFrontEnd + '/transcam/parametrage-tables', component: ParametrageTable, props: true, meta: { requiresAuth: false } },
            { name: 'MenuParametres', path: config.urlFrontEnd + '/transcam/parametres-menu', component: MenuParametres, props: true, meta: { requiresAuth: false } },
            { name: 'ErreursTransCAM', path: config.urlFrontEnd + '/transcam/erreurs', component: PageListeErreurTransCAM, }

        ]
    },
    { name: 'About', path: config.urlFrontEnd + '/about', component: About, meta: { requiresAuth: false } },
    { name: 'Accueil', path: config.urlFrontEnd + '/', component: PageConnexion, props: true, meta: { requiresAuth: false } },
    { name: 'ChoixAppli', path: config.urlFrontEnd + '/choixAppli', component: PageChoixApplication, props: true, meta: { requiresAuth: true } },
    { name: 'ModifierPatient', path: config.urlFrontEnd + '/ModifierPatient', component: FicheModif, props: false, meta: { requiresAuth: true } },
    { name: 'SaisieUtilisateur', path: config.urlFrontEnd + '/SaisieUtilisateur', component: FicheNouveau, props: false, meta: { requiresAuth: true } },

    // FISIMED
    { name: 'Fisimed', path: '/fisimed', component: Recherche, props: true },
    { name: 'FisimedRecherche', path: config.urlFrontEnd + '/Fisimed/recherche/', component: Recherche, props: true, meta: { requiresAuth: true } },
    { name: 'FisimedRechercheID', path: config.urlFrontEnd + '/Fisimed/recherche/:id', component: Recherche, props: true, meta: { requiresAuth: true } },

    // ALTYSE
    { name: 'Altyse', path: '/altyse', component: Recherche, props: true },
    { name: 'AltyseRecherche', path: config.urlFrontEnd + '/altyse/recherche/', component: Recherche, props: true, meta: { requiresAuth: true } },
    { name: 'AltyseRechercheID', path: config.urlFrontEnd + '/altyse/recherche/:id', component: Recherche, props: true, meta: { requiresAuth: true } },

    { name: 'Flic32', path: config.urlFrontEnd + '/flic32', component: Flic32, meta: { requiresAuth: true } },
    //{ name: 'NotFound', path: config.urlFrontEnd + '/:pathMatch(.*)', component: NotFound, meta: { title: '404 Not Found' } }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach(async (to, from, next) => {
    console.log("to.name = ", to.name);
    let isConnected = store.getters['ConnexionStore/getConnexionValeur'];
    console.log("beforeEach: isConnected =", isConnected);
    const token = localStorage.getItem('Token');
    
    // Vérifier l'authentification avec le token si disponible
    if (token) {
        try {
            const response = await Connexion.connecterWithTokenAsync();
            console.log("BeforeEach: connecterWithTokenAsync response =", response);
            
            // Mettre à jour l'état de connexion
            if (response && response.success) {
                store.dispatch("ConnexionStore/setConnexion", response);
                isConnected = true;
            } else {
                // Token invalide ou expiré
                store.dispatch("ConnexionStore/deconnexion");
                isConnected = false;
            }
        } catch (error) {
            console.error("Erreur dans beforeEach:", error);
            store.dispatch("ConnexionStore/deconnexion");
            isConnected = false;
        }
    }
    
    // Vérifier si la route nécessite une authentification
    if (to.meta && to.meta.requiresAuth) {
        if (!isConnected) {
            console.log("Connexion requise mais non connecté → redirection vers Accueil depuis : ", to.name);
            return next({ name: 'Accueil' });
        }
    }
    
    // Rediriger selon le login utilisé si déjà connecté et tentative d'accès à la page d'accueil
    if (to.name === 'Accueil' && isConnected) {
        const routeDejaConnecte = localStorage.getItem('redirigerVersChoixApplicationQuandDejaConnecte') === 'true'
            ? 'ChoixAppli'
            : 'TransCAM';
        console.log("Déjà connecté → redirection", routeDejaConnecte);
        return next({ name: routeDejaConnecte });
    }
    
    next();
});

export default router;
